/**
 * Button accessible roles.
 *
 * @public
 * @since 1.23
 */
enum ButtonAccessibleRole {

	/**
	 * Represents Default (button) ARIA role.
	 * @public
	 */
	Button = "Button",

	/**
	 * Represents the ARIA role "link".
	 * @public
	 */
	Link = "Link",
}

export default ButtonAccessibleRole;
